import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import { useSettings } from '../context/SettingsContext';

// Builds a wa.me link from admin-controlled number + prefilled message.
export function waLink(number, message) {
  const clean = String(number || '').replace(/[^0-9]/g, '');
  if (!clean) return null;
  const text = encodeURIComponent(message || 'Hi!');
  return `https://wa.me/${clean}?text=${text}`;
}

/**
 * Fills an admin-authored message template.
 * Supported placeholders: {product} {color} {service} {url} {site}
 * Unknown/empty placeholders are dropped and whitespace tidied.
 */
export function fillTemplate(template, vars = {}) {
  if (!template) return '';
  return template
    .replace(/\{(\w+)\}/g, (_, key) => vars[key] ?? '')
    .replace(/\(\s*\)/g, '')   // leftover empty brackets, e.g. "()"
    .replace(/\s{2,}/g, ' ')
    .replace(/\s+([.,!?])/g, '$1')
    .trim();
}

export default function WhatsAppFloat() {
  const { settings } = useSettings();
  if (!settings || !settings.whatsappEnabled) return null;
  const link = waLink(settings.whatsappNumber, settings.whatsappMessage);
  if (!link) return null;

  return (
    <motion.a
      href={link}
      target="_blank"
      rel="noreferrer"
      className="wa-float"
      aria-label="Chat on WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 0.8, type: 'spring', stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.92 }}
    >
      <span className="wa-float__pulse" />
      <FaWhatsapp />
      <span className="wa-float__label">Chat with us</span>
    </motion.a>
  );
}
